import React from 'react';
import tw from 'twin.macro'; // Assuming you're using twin.macro for styling

const IconButton = ({ onClick, children }) => {
  return (
    <button
      css={{
        height: 32,
        width: 32,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 5,
        transition: 'all 0.2s',
        fontWeight: 600,
        ':hover': {
          background: '#E8E8E8',
          color: '#1B1B1B',
        },
        ...tw`text-icon`,
      }}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default IconButton;
